<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-50 md-large-size-100">
      <Spiral
        v-if="spiralId !== null"
        ref="spiral"
        :id="spiralId"
        :shouldCopySpiral="shouldCopySpiral"
        @saved="getSpirals"
        @close="spiralId = null"
      />
      <SearchTable
        ref="spiralTable"
        :header="{
          title: 'Spirale',
          icon: 'animation',
          class: 'md-card-header-brand',
        }"
        :queriedData="spirals"
        :metaData="spiralMetaData"
        :getItems="getSpirals"
        :params="spiralParams"
        :sortBy="'id'"
        :individualFunction="[
          { function: copySpiral, class: 'md-round', icon: 'content_copy' },
        ]"
        :forEachSelected="[
          {
            icon: 'delete',
            label: 'Briši',
            class: 'md-danger',
            function: deleteSpirals,
          },
        ]"
        :openItem="openSpiral"
        :newItem="newSpiral"
      />
    </div>
    <div class="md-layout-item md-size-50 md-large-size-100">
      <Paper
        v-if="paperId !== null"
        :id="paperId"
        :shouldCopyPaper="shouldCopyPaper"
        @close="paperId = null"
        @saved="onPaperSaved"
      />
      <SearchTable
        ref="papersTable"
        :header="{
          title: 'Papiri',
          icon: 'file_copy',
          class: 'md-card-header-brand',
        }"
        :queriedData="papers"
        :metaData="papersMetaData"
        :getItems="getPapers"
        :params="papersParams"
        :openItem="openPaper"
        :newItem="newPaper"
        :sortBy="'id'"
        :individualFunction="[
          { function: copyPaper, class: 'md-round', icon: 'content_copy' },
        ]"
        :forEachSelected="[
          {
            icon: 'delete',
            label: 'Briši',
            class: 'md-danger',
            function: deletePapers,
          },
        ]"
      />
    </div>
  </div>
</template>

<script>
import Spiral from '@/components/Spiral.vue';
import Paper from '@/components/Paper.vue';
import SearchTable from '@/components/SearchTable.vue';
import services from '@/api/services';
import api from '@/api/api.js';
import Swal from 'sweetalert2';
import { cases } from '@/utils/helpers';

export default {
  components: {
    Spiral,
    Paper,
    SearchTable,
  },
  data() {
    return {
      spirals: [],
      spiralMetaData: null,
      spiralParams: {
        id: null,
        name: '',
        nodeLength: [null, null],
        gramPerNode: [null, null],
        description: '',
        nodesPerRoll: [null, null],
        pricePerMeter: [null, null],
      },
      papers: [],
      papersMetaData: null,
      papersParams: {
        id: null,
        paperGroupName: null,
        name: '',
        formatName: null,
        weight: [null, null],
        thickness: [null, null],
        slowPrint: [null, null],
        normalPrint: [null, null],
        fastPrint: [null, null],
      },
      spiralId: null,
      paperId: null,
      shouldCopySpiral: false,
      shouldCopyPaper: false,
    };
  },
  methods: {
    getSpirals(printTable = false) {
      const offset = this.spiralMetaData ? this.$refs.spiralTable.from : 0;
      const limit = this.spiralMetaData
        ? this.$refs.spiralTable.pagination.perPage
        : 75;
      const sortBy = this.spiralMetaData
        ? this.$refs.spiralTable.currentSort
        : null;
      const sortOrder = this.spiralMetaData
        ? this.$refs.spiralTable.currentSortOrder
        : null;
      api
        .get(services.itemCount.getSpirals, {
          getSpirals: true,
          params: this.spiralParams,
          offset,
          limit,
          sortBy,
          sortOrder,
          printTable,
        })
        .then((data) => {
          this.spirals = data.data;
          this.spiralMetaData = data.metaData;
        })
        .catch((error) => {
          this.alertError(error);
        });
    },
    getPapers(printTable = false) {
      const offset = this.papersMetaData ? this.$refs.papersTable.from : 0;
      const limit = this.papersMetaData
        ? this.$refs.papersTable.pagination.perPage
        : 75;
      const sortBy = this.papersMetaData
        ? this.$refs.papersTable.currentSort
        : null;
      const sortOrder = this.papersMetaData
        ? this.$refs.papersTable.currentSortOrder
        : null;
      api
        .get(services.itemCount.getPapers, {
          getPapers: true,
          params: this.papersParams,
          offset,
          limit,
          sortBy,
          sortOrder,
          printTable,
        })
        .then((data) => {
          this.papers = data.data;
          this.papersMetaData = data.metaData;
        })
        .catch((error) => {
          this.alertError(error);
        });
    },
    openSpiral(value) {
      this.spiralId = value.id;
      this.shouldCopySpiral = false;
    },
    openPaper(value) {
      this.paperId = value.id;
      this.shouldCopyPaper = false;
    },
    newSpiral() {
      this.spiralId = 0;
    },
    copySpiral(value) {
      this.spiralId = value.id;
      this.shouldCopySpiral = true;
    },
    onPaperSaved(id) {
      this.paperId = id;
      this.shouldCopyPaper = false;
      this.getPapers();
    },
    copyPaper(value) {
      this.paperId = value.id;
      this.shouldCopyPaper = true;
    },
    newPaper() {
      this.paperId = 0;
      this.shouldCopyPaper = true;
    },
    deleteSpirals(items) {
      const ids = items.map((el) => el.id);
      return Swal.fire({
        title: 'Briši spirale?',
        text: `Da li ste sigurni da želite da obrišete ${ids.length} ${cases(
          ids.length,
          'spiralu',
          'spirale',
          'spirala',
        )}?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-danger btn-fill',
        cancelButtonClass: 'md-button btn-fill',
        confirmButtonText: 'Obriši!',
        cancelButtonText: 'Otkaži',
        buttonsStyling: false,
      }).then((data) => {
        if (data.value) {
          api
            .post(services.itemCount.deleteSpirals, {
              deleteSpirals: true,
              ids,
            })
            .then(() => {
              this.getSpirals();
              this.$refs.spiralTable.removeChecked();
            })
            .catch((error) => {
              this.alertError(error);
            });
        }
      });
    },
    deletePapers(items) {
      const ids = items.map((el) => el.id);
      return Swal.fire({
        title: 'Briši papire?',
        text: `Da li ste sigurni da želite da obrišete ${ids.length} ${cases(
          ids.length,
          'papir',
          'papira',
          'papira',
        )}?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-danger btn-fill',
        cancelButtonClass: 'md-button btn-fill',
        confirmButtonText: 'Obriši!',
        cancelButtonText: 'Otkaži',
        buttonsStyling: false,
      }).then((data) => {
        if (data.value) {
          api
            .post(services.itemCount.deletePapers, {
              deletePapers: true,
              ids,
            })
            .then(() => {
              this.getPapers();
              this.$refs.papersTable.removeChecked();
            })
            .catch((error) => {
              this.alertError(error);
            });
        }
      });
    },
  },
  mounted() {
    this.getSpirals();
    this.getPapers();
  },
};
</script>
